export default {
    build: {
        mode: 'production' // 生产模式
    },
    apiHost: 'https://coinupusa.com/api',
    chargeAddress:'0x49553f29B9f550F064E0769013fCc7b2E21AC5d7',
};